var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between items-center"},[_c('h2',{staticClass:"title-text"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"flex align-center"},[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }